module.exports = __webpack_public_path__ + "media/images/games/world_culture_awareness/23-7cbdba91a7a75a94316aaaa7b96b7d51.png";